<template>
    <b-nav-item-dropdown
        id="price-search"
        menu-class="advanced-dropdown"
        text="Bérleti díj"
    >
        <price-search-form
            :url="url"
            :commercial="commercial"
            :min_price="min_price"
            :max_price="max_price"
        />

    </b-nav-item-dropdown>

</template>

<script>
  import {Vue, Component, Prop} from 'vue-property-decorator';
  import {namespace} from 'vuex-class';

  const priceSearchModule = namespace('price_search');

  @Component
  export default class PriceSearchMenu extends Vue {
    @Prop(String) url;
    @Prop(Boolean) commercial;
    @Prop(Number) min_price;
    @Prop(Number) max_price;

  }
</script>
